import cash from 'public/images/payment-icons/cash.svg';
import alipay from 'public/images/payment-icons/alipay.svg';
import amex from 'public/images/payment-icons/amex.svg';
import bca from 'public/images/payment-icons/bca.svg';
import bni from 'public/images/payment-icons/bni.svg';
import cimb from 'public/images/payment-icons/cimb.svg';
import dandan from 'public/images/payment-icons/dandan.svg';
import diners from 'public/images/payment-icons/diners.svg';
import discover from 'public/images/payment-icons/discover.svg';
import jcb from 'public/images/payment-icons/jcb.svg';
import lawson from 'public/images/payment-icons/lawson.svg';
import maestro from 'public/images/payment-icons/maestro.svg';
import mandiri from 'public/images/payment-icons/mandiri.svg';
import mastercard from 'public/images/payment-icons/mastercard.svg';
import paypal from 'public/images/payment-icons/paypal.svg';
import permata from 'public/images/payment-icons/permata.svg';
import unionpay from 'public/images/payment-icons/unionpay.svg';
import visa from 'public/images/payment-icons/visa.svg';
import corpbilling from 'public/images/payment-icons/corp-billing.svg';
import grabpay from 'public/images/payment-icons/grabpay.svg';
import OVO from 'public/images/payment-icons/ovo.svg';
import MOCA from 'public/images/payment-icons/moca.svg';
import generic from 'public/images/payment-icons/generic.svg';

export default {
  CASH: cash,
  Alipay: alipay,
  Amex: amex,
  BCA: bca,
  BNI: bni,
  Cimb: cimb,
  Dandan: dandan,
  Diners: diners,
  Discover: discover,
  JCB: jcb,
  Lawson: lawson,
  Maestro: maestro,
  Mandiri: mandiri,
  MasterCard: mastercard,
  Paypal: paypal,
  Permata: permata,
  Unionpay: unionpay,
  CUP: unionpay,
  Visa: visa,
  postpaidBilling: corpbilling,
  grabpay,
  OVO,
  MOCA,
  generic,
};
